import { z } from 'zod';

export const searchQuerySchema = z.object({
  q: z.string().trim().min(2).max(200),
  limit: z.coerce.number().int().min(1).max(50).default(20),
});
export type SearchQuery = z.infer<typeof searchQuerySchema>;

export interface SearchResultResponse {
  readonly moduleKey: string;
  readonly resourceType: string;
  readonly resourceId: string;
  readonly title: string;
  readonly subtitle: string | null;
}
